/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 定額プランの無料配信枠を超えたアラートを表示するかどうか
 * @export
 * @interface PressReleaseShouldShowLimitAlert
 */
export interface PressReleaseShouldShowLimitAlert {
    /**
     * 
     * @type {boolean}
     * @memberof PressReleaseShouldShowLimitAlert
     */
    shouldShowLimitAlert: boolean;
}

export function PressReleaseShouldShowLimitAlertFromJSON(json: any): PressReleaseShouldShowLimitAlert {
    return PressReleaseShouldShowLimitAlertFromJSONTyped(json, false);
}

export function PressReleaseShouldShowLimitAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseShouldShowLimitAlert {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shouldShowLimitAlert': json['should_show_limit_alert'],
    };
}

export function PressReleaseShouldShowLimitAlertToJSON(value?: PressReleaseShouldShowLimitAlert | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'should_show_limit_alert': value.shouldShowLimitAlert,
    };
}

